query CompanyCorporateYears($orderBy: [CompanyCorporateYearsOrderBy!]) {
  companyCorporateYears(orderBy: $orderBy) {
    nodes {
      id
      fiscalYear
      startDate
      endDate
      isYearOpen
      isEntryAllowed
      _rowTimestamp
      _isUpdatable
      _isDeletable
      companyCorporatePeriodsByFiscalYearId(orderBy: FISCAL_PERIOD_ASC) {
        totalCount
      }
    }
  }
}
